<template>
  <div id="app">
    <router-view v-if="isLoginPage" :key="$route.fullPath" />
    <Layout v-else class="shell-layout">
      <Sider :width="248" hide-trigger class="shell-sider">
        <div class="brand-block">
          <div class="brand-mark">SE</div>
          <div>
            <div class="brand-title">See 看板</div>
            <div class="brand-subtitle">Research Console</div>
          </div>
        </div>
        <Menu theme="dark" :active-name="activeMenu" @on-select="onSelect">
          <MenuItem name="overview">基础总览</MenuItem>
          <MenuItem name="trackingQuality">埋点质量</MenuItem>
          <MenuItem name="trackingEntry">入口点击</MenuItem>
          <MenuItem name="trackingDwell">停留时长</MenuItem>
          <MenuItem name="trackingEvaluation">版本评估</MenuItem>
          <MenuItem name="live">直播统计</MenuItem>
          <MenuItem name="profile">用户画像</MenuItem>
          <MenuGroup title="客户情绪与风险">
            <MenuItem name="customerRiskOverview">总览</MenuItem>
            <MenuItem name="customerRiskCustomers">客户池</MenuItem>
            <MenuItem name="customerRiskEvents">风险事件</MenuItem>
            <MenuItem name="customerRiskTeams">团队视图</MenuItem>
          </MenuGroup>
        </Menu>
        <div class="sider-footnote">
          <div>{{ $seeIsAdmin ? '可管理分析台' : '只读分析台' }}</div>
          <div>FastAPI + Vue 2</div>
        </div>
      </Sider>
      <Layout>
        <Header class="shell-header">
          <div>
            <div class="header-kicker">See Dashboard</div>
            <div class="header-title">{{ pageTitle }}</div>
          </div>
          <div class="header-meta">
            <div class="header-badge">{{ $seeIsAdmin ? 'Admin Mode' : 'Data Window' }}</div>
            <div class="header-user">{{ $seeCurrentUser.username || 'Guest' }}</div>
          </div>
        </Header>
        <Content class="shell-content">
          <router-view :key="$route.fullPath" />
        </Content>
      </Layout>
    </Layout>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    isLoginPage() {
      return this.$route.path === '/login';
    },
    activeMenu() {
      return this.$route.meta && this.$route.meta.activeMenu ? this.$route.meta.activeMenu : this.$route.name;
    },
    pageTitle() {
      return this.$route.meta && this.$route.meta.title ? this.$route.meta.title : '看板';
    }
  },
  methods: {
    onSelect(name) {
      const route = {
        overview: '/overview',
        trackingQuality: '/tracking-quality',
        trackingEntry: '/tracking-entry',
        trackingDwell: '/tracking-dwell',
        trackingEvaluation: '/tracking-evaluation',
        live: '/live',
        profile: '/profile',
        customerRiskOverview: '/customer-risk/overview',
        customerRiskCustomers: '/customer-risk/customers',
        customerRiskEvents: '/customer-risk/events',
        customerRiskTeams: '/customer-risk/teams'
      };
      const path = route[name];
      if (path && path !== this.$route.path) {
        this.$router.push(path);
      }
    }
  }
};
</script>

<style scoped>
.shell-layout {
  min-height: 100vh;
}

.shell-sider {
  position: sticky;
  top: 0;
  left: 0;
  height: 100vh;
  padding: 18px 0 16px;
  box-shadow: inset -1px 0 0 rgba(255, 255, 255, 0.06);
}

.brand-block {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 0 18px 18px;
  margin: 0 10px 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.brand-mark {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  font-weight: 700;
  color: #fff7ef;
  background: linear-gradient(135deg, #f05a28 0%, #d9a441 100%);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.brand-title {
  color: #fff7ef;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.03em;
}

.brand-subtitle {
  color: rgba(255, 247, 239, 0.68);
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.12em;
}

.sider-footnote {
  position: absolute;
  left: 20px;
  right: 20px;
  bottom: 18px;
  padding: 12px 14px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 247, 239, 0.78);
  font-size: 12px;
}

.shell-header {
  height: auto;
  line-height: 1.2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 28px 8px;
}

.header-kicker {
  color: var(--text-soft);
  font-size: 12px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.header-title {
  font-size: 30px;
  font-weight: 700;
  color: var(--brand-deep);
}

.header-badge {
  padding: 10px 14px;
  border-radius: 999px;
  background: rgba(255, 250, 243, 0.72);
  border: 1px solid rgba(15, 76, 92, 0.12);
  color: var(--brand-deep);
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.header-meta {
  display: flex;
  align-items: center;
  gap: 10px;
}

.header-user {
  color: var(--text-soft);
  font-size: 12px;
}

.shell-content {
  padding: 12px 28px 28px;
}

@media (max-width: 768px) {
  .shell-header {
    padding: 18px 18px 8px;
  }

  .shell-content {
    padding: 10px 18px 18px;
  }

  .header-title {
    font-size: 24px;
  }
}
</style>
